import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { AnalyticsStore } from 'bernie-core';
import { ClickTracker } from 'bernie-analytics';
import { Context } from 'bernie-context';

import { ShortlistStore } from 'stores/shortlist-store';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLinkButton } from 'uitk-react-button';
const TrackedButton = ClickTracker(UitkLinkButton);

export interface RemoveButtonProps {
  analytics?: AnalyticsStore;
  referralObject?: {
    close?: {
      rfrr: string;
      linkName?: string;
    };
  };
  category: string;
  hotelId: number;
  rfrr: string;
  shortlist?: ShortlistStore;
  context?: Context;
  removeUrl: string;
  meta: any;
  displayViewed: boolean;
}

@inject('shortlist', 'context', 'analytics')
@observer
export class RemoveButton extends React.Component<RemoveButtonProps> {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  public handleClick() {
    const { shortlist, hotelId, category, meta, context, removeUrl, analytics, displayViewed } = this.props;
    if (shortlist && typeof shortlist.removeReplayItem === 'function' && hotelId && category) {
      const isFavorited = this.getHotelStatusInShortlist(shortlist[category], hotelId, 'favorited');
      const isRecentlyViewed = this.getHotelStatusInShortlist(shortlist[category], hotelId, 'recentlyViewed');

      shortlist.removeReplayItem(context, hotelId, category, removeUrl, meta);

      if (isRecentlyViewed && displayViewed) {
        const trackingDataRecentlyViewed = {
          rfrr: `ViewedHotels.${shortlist[category].recentlyViewed.length}`,
          linkName: 'Number of viewed hotels'
        };
        analytics.trackEvent(trackingDataRecentlyViewed.rfrr, trackingDataRecentlyViewed.linkName, analytics.omnitureData, null);
      }

      if (isFavorited) {
        const trackingDataNumberOfHearted = {
          rfrr: `FavoritedHotels.${shortlist[category].favorited.length}`,
          linkName: 'Number of favorited hotels'
        };
        analytics.trackEvent(trackingDataNumberOfHearted.rfrr, trackingDataNumberOfHearted.linkName, analytics.omnitureData, null);
      }
    }

    if (shortlist && typeof shortlist.updateFavoritedLocally === 'function' && hotelId) {
      shortlist.updateFavoritedLocally(hotelId, false, 'hotel');
    }
  }

  private getHotelStatusInShortlist(list, hotelId, field) {
    return list && list[field] && list[field].some(e => e.id === hotelId);
  }

  public getReferrals() {
    const referralObject = this.props.referralObject || {};
    const defaultClose = {
      rfrr: 'Scratchpad.CloseViewed',
      linkName: 'Remove selected hotel'
    };

    return {
      ...referralObject,
      close: {
        ...defaultClose,
        ...referralObject.close
      }
    };
  }

  public render() {
    const { hotelId } = this.props;
    const referralObject = this.getReferrals();
    const rfrr = referralObject.close.rfrr;
    const linkName = referralObject.close.linkName;

    return (
      <TrackedButton
        className="remove-listing-button"
        id={`replay-remove-${hotelId}`}
        rfrr={rfrr}
        linkName={linkName}
        onClick={this.handleClick}
      >
        <div className="all-y-margin-three all-x-margin-three">
          <UitkIcon className="pwa-theme--color-white" name="close" size={UitkIconSize.MEDIUM} />
        </div>
      </TrackedButton>
    );
  }
}
